// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a00093d8","453":"5877bb1e","455":"d0dbd621"}[chunkId] + ".chunk.js";
};